import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection
} from '@angular/core'
import {provideRouter, withHashLocation} from '@angular/router'

import {routes} from './app.routes'
import {
  provideAnimationsAsync
} from '@angular/platform-browser/animations/async'
import {registerLocaleData} from '@angular/common'
import localeFrExtra from '@angular/common/locales/extra/fr'
import localeSvExtra from '@angular/common/locales/extra/sv'
import localeFr from '@angular/common/locales/fr'
import localeSv from '@angular/common/locales/sv'
import {provideHttpClient} from '@angular/common/http'

registerLocaleData(localeFr, 'fr', localeFrExtra)
registerLocaleData(localeSv, 'sv', localeSvExtra)

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: LOCALE_ID, useValue: 'sv-SE'},
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withHashLocation()),
    provideAnimationsAsync(),
    provideHttpClient()
  ]
}
